import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { OidcService } from '@revenuewell/logic-oidc';

export class ProductService extends AuthApiService {
    private config: any

    constructor(config: any, oidcService: OidcService, navigationService: NavigationService) {
        super(oidcService, navigationService)
        this.config = config;
    }

    getAvailableProducts = async (locationId: number): Promise<string[]> => {
        const url = `${this.config.product.apiUrl}/Product/GetAvailableProducts?locationId=${locationId}`
        const response = await this.authFetch(url, { method: 'GET' }, { ttlSeconds: 60 })
        return response.json()
    }
}